(function() {
    class FeaturesCarouselv1 extends HTMLElement {
      constructor() {
        super();
        this.scrollContainer = null;
        this.dots = [];
        this.items = [];
        this.currentIndex = 0;
        this.autoScrollInterval = null;
      }

      connectedCallback() {
        this.scrollContainer = this.querySelector('.ai-features-scroll-v1');
        this.dots = Array.from(this.querySelectorAll('.ai-features-dot-v1'));
        this.items = Array.from(this.querySelectorAll('.ai-feature-item-v1'));

        if (window.innerWidth < 750) {
          this.setupMobileCarousel();
        }

        window.addEventListener('resize', () => {
          if (window.innerWidth < 750) {
            this.setupMobileCarousel();
          } else {
            this.destroyMobileCarousel();
          }
        });
      }

      setupMobileCarousel() {
        if (!this.scrollContainer) return;

        this.scrollContainer.addEventListener('scroll', this.handleScroll.bind(this));

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            this.scrollToIndex(index);
          });
        });

        this.startAutoScroll();
      }

      destroyMobileCarousel() {
        this.stopAutoScroll();
      }

      handleScroll() {
        if (!this.scrollContainer) return;

        const scrollLeft = this.scrollContainer.scrollLeft;
        const itemWidth = this.items[0]?.offsetWidth || 0;
        const newIndex = Math.round(scrollLeft / itemWidth);

        if (newIndex !== this.currentIndex) {
          this.currentIndex = newIndex;
          this.updateDots();
        }
      }

      scrollToIndex(index) {
        if (!this.scrollContainer || !this.items[index]) return;

        const itemWidth = this.items[0].offsetWidth;
        const gap = parseInt(getComputedStyle(this.scrollContainer.parentElement).gap) || 0;
        const scrollPosition = index * (itemWidth + gap);

        this.scrollContainer.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        });

        this.currentIndex = index;
        this.updateDots();
        this.resetAutoScroll();
      }

      updateDots() {
        this.dots.forEach((dot, index) => {
          if (index === this.currentIndex) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      }

      startAutoScroll() {
        this.autoScrollInterval = setInterval(() => {
          const nextIndex = (this.currentIndex + 1) % this.items.length;
          this.scrollToIndex(nextIndex);
        }, 7000);
      }

      stopAutoScroll() {
        if (this.autoScrollInterval) {
          clearInterval(this.autoScrollInterval);
          this.autoScrollInterval = null;
        }
      }

      resetAutoScroll() {
        this.stopAutoScroll();
        this.startAutoScroll();
      }

      disconnectedCallback() {
        this.stopAutoScroll();
      }
    }

    customElements.define('features-carousel-v1', FeaturesCarouselv1);
  })();